export default "__VITE_ASSET__231f1ebb__"